import React, { InputHTMLAttributes, ReactNode, useEffect, useState, } from 'react';
import { Table } from "flowbite-react";

import CustomThemeTable from '../CustomThemes/CustomThemeTable';
import { IRequestMemberType } from '../../types/IRequestMemberType';

interface ViewMembersFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    itemNumber?: number;
    labelName?: ReactNode;
    requestMember: IRequestMemberType[];
}

const ViewMembersField: React.FC<ViewMembersFieldProps> = ({ itemNumber, labelName, requestMember }) => {

    return (
        <div className="mb-8">
            <div className="flex">
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                <div className="text-sm">{labelName}</div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow mt-3">
                    <Table theme={CustomThemeTable}>

                        <Table.Head>
                            <Table.HeadCell>Name</Table.HeadCell>
                            <Table.HeadCell>Primary</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">

                            {requestMember.map((member, index) => {
                                return (
                                    <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800" key={index}>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">{member.first_name} {member.last_name}</div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {member.is_primary && <>Primary Requestor</>}
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })}

                        </Table.Body>

                    </Table>
                </div>
            </div>
        </div>
    )
}

export default ViewMembersField;